type HeaderProps = {
  title: string;
  onMenuClick: () => void;
};

export function Header({ title, onMenuClick }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-gray-200 bg-white">
      <div className="flex h-16 items-center gap-4 px-4 sm:px-6 lg:px-8">
        <button
          type="button"
          className="text-gray-500 lg:hidden"
          onClick={onMenuClick}
          aria-label="Menü öffnen"
          aria-controls="sidebar"
        >
          <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" />
          </svg>
        </button>
        <h1 className="text-lg font-semibold text-gray-800">{title}</h1>
      </div>
    </header>
  );
}
